import { AsyncWidgetConfigurationNav } from '@jira/navigation-apps__horizontal-nav-csm-widget-configuration/src/AsyncWidgetConfigurationNav.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { csmExperienceWidgetConfigurationCustomizeRoute } from '@jira/router-routes__help-center-settings-routes/src/csmExperienceWidgetConfigurationCustomizeRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';
import { HelpCenterSettingsWidgetConfigurationCustomizeEntryPoint } from './ui/widget-configuration-customize/HelpCenterSettingsWidgetConfigurationCustomizeEntryPoint.tsx';

export const csmExperienceWidgetConfigurationCustomizeRouteEntry: Route = createEntry(
	csmExperienceWidgetConfigurationCustomizeRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'customer-service.csm-experience-widget-configuration.customize',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
			sidebarId: SidebarIdCsmApp,
			horizontal: AsyncWidgetConfigurationNav,
		},
		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? HelpCenterSettingsWidgetConfigurationCustomizeEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [
			...getCustomerServiceL1NavigationResources(),
			...getCsmExperiencesResources(),
			staticProjectSidebarNavigationResource,
		],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
